import { FilterDescriptor } from '@progress/kendo-data-query'
import { useAppSelector } from 'store'

import { SelectFilter } from '../SelectFilter'

interface InstrumentTypeFilterProps {
  filter: FilterDescriptor
  onFilterChange: (event: { nextFilter: FilterDescriptor }) => void
}

export const InstrumentTypeFilter: React.FC<InstrumentTypeFilterProps> = (props) => {
  const { filter, onFilterChange } = props
  const instrumentTypes = useAppSelector(
    (state) => state.tradingAccounts.tradingAccountInstrumentType
  )

  const data = instrumentTypes.map((x) => ({ id: x.id, label: x.name, value: x.id }))

  return (
    <SelectFilter
      placeholder='Instrument Type'
      filter={filter}
      onFilterChange={onFilterChange}
      data={data}
      style={{ width: 240 }}
    />
  )
}
